export const authenticatedPatientSelector = (state) => {
  if (state.session.authenticatedPatientId) {
    return state.patients[state.session.authenticatedPatientId];
  }

  return null;
};

export const currentPatientSelector = (state) => {
  if (state.currentPatient.id) {
    return state.patients[state.currentPatient.id];
  }

  return null;
};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/selectors/patients-selectors.ts